import fs from 'node:fs'
import path from 'node:path'
import type { SchemaOwnershipIndex } from '@cli-types/preset-engine/presets.js'
import { stringifyProjectJson } from '@cli-utils/shared.js'
import { ownershipPath } from './ownership-path.js'

export function saveSchemaOwnershipIndex(cwd: string, index: SchemaOwnershipIndex): void {
  const filePath = ownershipPath(cwd)
  fs.mkdirSync(path.dirname(filePath), { recursive: true })
  fs.writeFileSync(filePath, stringifyProjectJson(index), 'utf-8')
}
